import { maybeLocale } from '@wework/universal-locale-utils';
import { varsFromServer } from '../client_side_injection_vars';

export function localizeLink({ to = '/', locale = getLocale() }) {
  const separator = to[0] === '/' ? '' : '/';
  const link = `${maybeLocale(locale)}${separator}${to}`;
  return link;
}

export function getLocale() {
  const DEFAULT_LOCALE = 'en';
  return varsFromServer.locale || DEFAULT_LOCALE;
}

export function getSelectedLocale() {
  return varsFromServer.locale;
}

export function stripOutLocale(url = '') {
  if (url) {
    return url.replace(/([a-z]{2}-[A-Z]{2}\/)/g, '');
  }
  return url;
}

export function ISODateToLocalizedShortDate(date, utc = true) {
  const { locale } = varsFromServer;
  const options = {
    month: 'short',
    day: '2-digit',
    ...(utc && { timeZone: 'UTC' })
  };

  const currentYear = new Date().getFullYear();
  const datesYear = new Date(date).getFullYear();
  if (datesYear > currentYear) {
    options.year = 'numeric';
  }

  const shortDate = new Date(date).toLocaleDateString(locale, options);
  return shortDate;
}
